var map = {
	"./Branding/HW": 1,
	"./Branding/HW Colour Codes _ Font": 2,
	"./Branding/HW Colour Codes _ Font.png": 2,
	"./Branding/HW Mark 1": 3,
	"./Branding/HW Mark 1 square": 4,
	"./Branding/HW Mark 1 square.png": 4,
	"./Branding/HW Mark 1.png": 3,
	"./Branding/HW Mark 2": 5,
	"./Branding/HW Mark 2.png": 5,
	"./Branding/HW Mark Red": 6,
	"./Branding/HW Mark Red.png": 6,
	"./Branding/HW Red 1": 7,
	"./Branding/HW Red 1.png": 7,
	"./Branding/HW Red 2": 8,
	"./Branding/HW Red 2.png": 8,
	"./Branding/HW Red 3": 9,
	"./Branding/HW Red 3.png": 9,
	"./Branding/HW Small": 10,
	"./Branding/HW Small.png": 10,
	"./Branding/HW Vertical 1": 11,
	"./Branding/HW Vertical 1.png": 11,
	"./Branding/HW Vertical 2": 12,
	"./Branding/HW Vertical 2.png": 12,
	"./Branding/HW Word": 13,
	"./Branding/HW Word.png": 13,
	"./Branding/HW Word_W": 14,
	"./Branding/HW Word_W.png": 14,
	"./Branding/HW.png": 1,
	"./Branding/HW_White": 15,
	"./Branding/HW_White.png": 15,
	"./antara1": 16,
	"./antara1.png": 16,
	"./antara1_star": 17,
	"./antara1_star square": 18,
	"./antara1_star square.png": 18,
	"./antara1_star.png": 17,
	"./avatar": 19,
	"./avatar.png": 19,
	"./categories/R.programming": 20,
	"./categories/R.programming copy": 21,
	"./categories/R.programming copy.png": 21,
	"./categories/R.programming.png": 20,
	"./categories/R_logo_hw_darkred": 22,
	"./categories/R_logo_hw_darkred.png": 22,
	"./categories/R_logo_hw_red": 23,
	"./categories/R_logo_hw_red.png": 23,
	"./categories/r-splash-meta-tag": 24,
	"./categories/r-splash-meta-tag.png": 24,
	"./categories/r-splash-meta-tag2": 25,
	"./categories/r-splash-meta-tag2.png": 25,
	"./categories/r-stats-splash": 26,
	"./categories/r-stats-splash.png": 26,
	"./fb_index_image": 27,
	"./fb_index_image.png": 27,
	"./fb_index_image2": 28,
	"./fb_index_image2.png": 28,
	"./fb_index_image3": 29,
	"./fb_index_image3.png": 29,
	"./freelogodesign1": 30,
	"./freelogodesign1.png": 30,
	"./freelogodesign1_green": 31,
	"./freelogodesign1_green.png": 31,
	"./join-us-on-slack": 32,
	"./join-us-on-slack.png": 32,
	"./logo1": 33,
	"./logo1.png": 33,
	"./logo1_nodc": 34,
	"./logo1_nodc.png": 34,
	"./logo2_baloo": 35,
	"./logo2_baloo.png": 35,
	"./meetlogo": 36,
	"./meetlogo.png": 36,
	"./placeholder": 37,
	"./placeholder.png": 37,
	"./powered_by_stripe": 38,
	"./powered_by_stripe.png": 38,
	"./seeds/Yasser": 39,
	"./seeds/Yasser.jpg": 39,
	"./seeds/andy": 40,
	"./seeds/andy.jpeg": 40,
	"./seeds/ben": 41,
	"./seeds/ben.jpg": 41,
	"./seeds/botez": 42,
	"./seeds/botez.jpeg": 42,
	"./seeds/fab": 43,
	"./seeds/fab.jpg": 43,
	"./seeds/johnb": 44,
	"./seeds/johnb.jpg": 44,
	"./seeds/pieter": 45,
	"./seeds/pieter.png": 45,
	"./seeds/steve": 46,
	"./seeds/steve.png": 46,
	"./seeds/steveb": 47,
	"./seeds/steveb.jpg": 47,
	"./seeds/talljohn": 48,
	"./seeds/talljohn.jpg": 48,
	"./socials/chessdotcom": 49,
	"./socials/chessdotcom.png": 49,
	"./socials/facebook": 50,
	"./socials/facebook.png": 50,
	"./socials/github": 51,
	"./socials/github.png": 51,
	"./socials/instagram": 52,
	"./socials/instagram.png": 52,
	"./socials/kaggle": 53,
	"./socials/kaggle.png": 53,
	"./socials/lichess": 54,
	"./socials/lichess.png": 54,
	"./socials/linkedin": 55,
	"./socials/linkedin.png": 55,
	"./socials/reddit": 56,
	"./socials/reddit.png": 56,
	"./socials/snapchat": 57,
	"./socials/snapchat.png": 57,
	"./socials/stackoverflow": 58,
	"./socials/stackoverflow.png": 58,
	"./socials/tiktok": 59,
	"./socials/tiktok.png": 59,
	"./socials/twitch": 60,
	"./socials/twitch.png": 60,
	"./socials/twitter": 61,
	"./socials/twitter.png": 61,
	"./socials/yc": 62,
	"./socials/yc.png": 62,
	"./socials/youtube": 63,
	"./socials/youtube.png": 63,
	"./user_icon": 64,
	"./user_icon.png": 64,
	"./user_icon2": 65,
	"./user_icon2.png": 65,
	"./zoom": 66,
	"./zoom-icon": 67,
	"./zoom-icon.jpg": 67,
	"./zoom.jpg": 66,
	"./zoom2": 68,
	"./zoom2.jpg": 68,
	"./zoomlogo": 69,
	"./zoomlogo.png": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;